import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.AmountInfoExpenseReport', {
    totalExpenses: 'Total Expenses:',
    advance: 'Advance to apply:',
    reimbursableAmount: 'Total reimbursable amount:',
});
